var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pomnicky"}},[_c('div',{attrs:{"id":"pozadi1"}},[_c('img',{attrs:{"src":require(("./../assets/" + (_vm.innerParams.background))),"alt":("" + (_vm.innerParams.backgroundDescription))}})]),(_vm.innerParams.transbox)?_c('div',{staticClass:"transbox1",style:({ backgroundColor: _vm.innerParams.transbox })}):_c('div',{staticClass:"transbox1"}),_c('h1',[_vm._v(" "+_vm._s(_vm.innerParams.nadpis)+" ")]),(
      !this.$route.params.kategorie &&
      !this.$route.params.id &&
      _vm.innerParams.stranka !== 'vypraveni' &&
      _vm.innerParams.stranka !== 'cesty' &&
      _vm.innerParams.stranka !== 'novepridane'
    )?_c('AbecedniSeznam',{staticClass:"abSeznam",attrs:{"stranka":_vm.innerParams.stranka}}):_vm._e(),_c('div',{class:{
      pomnickyText: true,
      large:
        _vm.innerParams.stranka === 'vypraveni' ||
        _vm.innerParams.stranka === 'cesty' ||
        _vm.innerParams.stranka === 'novepridane',
    }},_vm._l((_vm.innerParams.uvodniText),function(odstavec,index){return _c('div',{key:index,attrs:{"id":"pomnickyUvod"}},[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(odstavec.textOdstavce)}}),(odstavec.vnitrniOdkazy)?_c('span',[_c('Klikaci',{attrs:{"clanek":odstavec,"kdeJsem":"odstavec"}})],1):_vm._e()])])}),0),_c('div',{attrs:{"id":"rozbalitWrapper"}},[_c('router-link',{attrs:{"to":("/" + (_vm.innerParams.stranka) + (_vm.$route.name === 'NovePridane' || _vm.$route.name === 'NovePridaneLong' ? '' : '/' + _vm.$route.params.kategorie) + (!_vm.isLongVersion ? '/long' : ''))}},[(
          _vm.$route.name === 'SmirciKrizeKategorie' ||
          _vm.$route.name === 'PomnickyKategorie' ||
          _vm.$route.name === 'StudankyKategorie' ||
          _vm.$route.name === 'NovePridane' ||
          _vm.isLongVersion
        )?_c('div',{staticClass:"commonButton",attrs:{"id":"rozbalit"}},[_vm._v(" "+_vm._s(_vm.isLongVersion ? "Zkrácená verze" : "Rozbalit vše")+" ")]):_vm._e()])],1),_c('router-link',{staticClass:"commonButton",attrs:{"to":"/","id":"tlacitkoDomu"}},[_vm._v(" Úvodní strana ")]),_c('div',{staticClass:"commonButton",attrs:{"id":"tlacitkoNahoru"},on:{"click":_vm.goToTop}},[_vm._v("Nahoru ")]),(
      this.$route.name === 'NovyPomnicek' ||
      this.$route.name === 'NovyKriz' ||
      this.$route.name === 'NovaStudanka'
    )?_c('span',{staticClass:"commonButton",attrs:{"id":"naNovePridane"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Nové")]):_vm._e(),_c('router-link',{attrs:{"to":("/" + (_vm.innerParams.stranka)),"id":"ABClink"}},[(
        this.$route.params.kategorie ||
        (this.$route.params.id &&
          _vm.innerParams.stranka !== 'vypraveni' &&
          _vm.innerParams.stranka !== 'cesty')
      )?_c('div',{staticClass:"commonButton",attrs:{"id":"seznam"}},[_vm._v(" ABC ")]):_vm._e()]),(
      _vm.innerParams.stranka === 'pomnicky' ||
      _vm.innerParams.stranka === 'krize' ||
      _vm.innerParams.stranka === 'studanky'
    )?_c('div',{staticClass:"pomnickyNavigace"},_vm._l((_vm.innerParams.kategoriePomnicky),function(kategorie){return _c('div',{key:kategorie.nazev},[_c('router-link',{attrs:{"to":("/" + (_vm.innerParams.stranka) + "/" + (kategorie.id))}},[_c('div',{class:{
            tyrkys: _vm.innerParams.stranka === 'krize',
            hneda: _vm.innerParams.stranka === 'pomnicky',
            fialova: _vm.innerParams.stranka === 'studanky',
            commonButton: true,
            kategorieTextCenter:
              _vm.innerParams === 'cesty' || _vm.innerParams === 'vypraveni',
            active: _vm.vybranaId.includes(kategorie.id),
            podkategorie: true,
          },style:({ backgroundColor: _vm.innerParams.buttonsColor })},[_vm._v(" "+_vm._s(kategorie.nazev)+" ("+_vm._s(kategorie.pocet)+") ")])])],1)}),0):_vm._e(),(
      this.$route.name !== 'Pomnicky' &&
      this.$route.name !== 'SmirciKrize' &&
      this.$route.name !== 'Studanky'
    )?_c('div',{staticClass:"kontejner",class:{
      kontejnerBigMargin:
        _vm.innerParams.stranka === 'vypraveni' ||
        _vm.innerParams.stranka === 'cesty',
      kontejnerSmallMargin:
        _vm.innerParams.stranka === 'pomnicky' ||
        _vm.innerParams.stranka === 'krize' ||
        _vm.innerParams.stranka === 'studanky',
      large:
        _vm.innerParams.stranka === 'vypraveni' ||
        _vm.innerParams.stranka === 'cesty' ||
        _vm.innerParams.stranka === 'novepridane',
      bezTextu: _vm.innerParams.detail,
    }},[_c('div',[(
          this.$route.name === 'NovePridane' ||
          this.$route.name === 'NovePridaneLong' ||
          this.$route.name === 'PomnickyKategorie' ||
          this.$route.name === 'SmirciKrizeKategorie' ||
          this.$route.name === 'StudankyKategorie' ||
          this.$route.name === 'Vypraveni' ||
          this.$route.name === 'Cesty'
        )?_c('OknoClanky',{attrs:{"stranka":_vm.innerParams.stranka,"zalozky":!_vm.isLongVersion}}):_vm._e(),(
          this.$route.name === 'PomnickyKategorieLong' ||
          this.$route.name === 'DetailPomnicku' ||
          this.$route.name === 'SmirciKrizeKategorieLong' ||
          this.$route.name === 'StudankyKategorieLong' ||
          this.$route.name === 'NovePridaneLong' ||
          this.$route.name === 'DetailKrize' ||
          this.$route.name === 'DetailStudanky' ||
          this.$route.name === 'NovyPomnicek' ||
          this.$route.name === 'NovyKriz' ||
          this.$route.name === 'NovaStudanka'
        )?_c('OknoPomnicky',{attrs:{"kategoriePomnicky":_vm.innerParams.kategoriePomnicky,"stranka":_vm.innerParams.stranka,"zalozky":!_vm.isLongVersion}}):_vm._e()],1)]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }